<!-- 考前温馨提示 -->
<template>
  <div class="frame">
    <el-dialog
      :visible.sync="show"
      width="500px"
      top="40vh"
      center
      :before-close="beforeClose"
    >
      <div class="contain">
        需要完成所有培训课程才能继续考试，若已完成培训，则点击继续
      </div>
      <span slot="footer">
        <el-button size="small" @click="beforeClose">取消</el-button>
        <el-button
          size="small"
          type="primary"
          :disabled="continueCountDown != 0"
          @click="continueTest"
        >
          <span v-show="continueCountDown != 0">{{ continueCountDown }}s</span>
          承诺已完成培训，继续考试</el-button
        >
      </span>
    </el-dialog>
    <header class="header">
      <div class="topbar">
        <span>欢迎访问四川省建协人才服务中心</span>
        <el-dropdown @command="dropdownChange">
          <div class="dropdown-out">
            <span>{{ userInfo.idNum }}</span>
            <i class="el-icon-arrow-down el-icon--right"></i>
          </div>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="/mine/profile"
              >个人中心</el-dropdown-item
            >
            <el-dropdown-item command="exit">退出</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </header>
    <div class="top">
      <div class="back-box">
        <div class="back" @click="navBack">
          <i class="el-icon-arrow-left"></i>
          <span>返回</span>
        </div>
      </div>
      <div class="title">{{ paper.paperTitle }}</div>
      <div class="desc">
        <!-- <span>到期时间：2025-05-20</span> -->
      </div>
    </div>
    <div class="content">
      <div class="in">
        <div class="tabs">
          <div class="tab active">正式考试</div>
          <!-- <div class="tab">考试记录</div> -->
        </div>
        <div class="rich">
          <p>本考场开启时间 不限 ； 考试次数 不限 ； 抽卷规则 系统随机抽卷。</p>
          <p>1、点击考试名称按钮进入答题界面，考试开始计时。</p>
          <p>
            2、在随机考试过程中，您可以通过顶部的考试时间来掌握自己的做题时间。
          </p>
          <p>3、确认已完成所有培训课程。</p>
        </div>
        <div class="menus">
          <router-link to="/train" class="btn red"
            >未参加培训，前往培训</router-link
          >
          <div class="btn primary" @click="startTest">开始考试</div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Footer from "../layout/components/foot.vue";
export default {
  components: { Footer },
  data() {
    return {
      userInfo: {},
      paper: {},
      show: false,
      continueCountDown: 5,
      timer: null,
    };
  },
  created() {
    this.userInfo = JSON.parse(localStorage.getItem("userInfo"));
    this.$api.getPaperById({ id: this.$route.params.id }).then((res) => {
      if (res.code == 0) {
        this.paper = res.data;
      }
    });
  },
  methods: {
    navBack() {
      this.$router.back();
    },
    dropdownChange(command) {
      if (command == "exit") {
        this.$confirm("确认退出登录？", "提示", {
          type: "warning",
        }).then(() => {
          this.$router.push("/");
          localStorage.removeItem("token");
          localStorage.removeItem("userInfo");
        });
        return;
      }
      this.$router.push(command);
    },
    // 承诺培训倒计时
    startTest() {
      this.show = true;
      this.timer = setInterval(() => {
        this.continueCountDown--;
        if (this.continueCountDown == 0) {
          clearInterval(this.timer);
        }
      }, 1000);
    },
    beforeClose() {
      this.show = false;
      clearInterval(this.timer);
      this.continueCountDown = 5;
    },
    // 继续考试
    continueTest() {
      this.$api.updateApplyTrainTime({ id: this.$route.query.applyId }); // 添加培训时间
      const loading = this.$loading({
        lock: true,
        text: "正在抽题，即将进入考试页面",
        background: "rgba(0, 0, 0, 0.7)",
      });
      setTimeout(() => {
        loading.close();
        this.$router.replace("/test/" + this.$route.params.id);
      }, 2000);
    },
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
};
</script>

<style lang="scss" scoped>
.frame {
  background-color: #f9f9f9;
}
.header {
  width: 100%;
  background-color: #363636;

  .topbar {
    line-height: 36px;
    color: #fff;
    width: 1200px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    font-size: 12px;

    .exit {
      cursor: pointer;

      &:hover {
        color: $theme;
      }
    }
  }
  .dropdown-out {
    color: #fff;
  }
}
.top {
  width: 100%;
  height: 200px;
  background-color: #409eff;
  clip-path: polygon(
    0 0,
    100% 0,
    100% calc(100% - 30px),
    calc(50% + 370px) 100%,
    47% calc(100% - 27px),
    calc(50% - 370px) 100%,
    0 calc(100% - 30px)
  );
  color: #fff;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;

  .back-box {
    width: 1200px;
    position: absolute;
    top: 20px;
    left: 50%;
    transform: translateX(-50%);
    display: flex;

    .back {
      color: #fff;
      font-size: 20px;
      cursor: pointer;

      &:hover {
        color: $theme;
      }
    }
  }

  .title {
    font-size: 40px;
    font-weight: bold;
    margin-bottom: 10px;
  }
  .desc {
    font-size: 18px;
  }
}
.content {
  min-height: 60vh;
  padding: 20px 0;
  margin-top: 10px;
  background-color: #fff;
  box-shadow: 0 0 5px #eee;

  .in {
    width: 1200px;
    margin: 0 auto;
    padding: 0 20px;

    .tabs {
      display: flex;
      border-bottom: 1px solid #eeeeee;
      line-height: 40px;
      font-weight: 500;

      .tab {
        padding: 0 10px;
        cursor: pointer;

        & + .tab {
          margin-left: 10px;
        }
        &:hover {
          font-weight: bold;
          border-bottom: 2px solid #333;
        }
      }

      .active {
        font-weight: bold;
        border-bottom: 2px solid #333;
      }
    }
    .rich {
      padding: 20px 0;
      border-bottom: 1px solid #eeeeee;
      color: #999999;
      font-size: 15px;

      p {
        margin-bottom: 10px;
        line-height: 28px;
      }
    }
    .menus {
      padding: 10px 0;
      display: flex;
      justify-content: center;

      .btn {
        padding: 10px 15px;
        color: #fff;
        font-size: 14px;
        border-radius: 4px;
        display: block;
        cursor: pointer;

        & + .btn {
          margin-left: 10px;
        }
      }
      .red {
        background-color: #f44336;
      }
      .primary {
        background-color: #409eff;
      }
    }
  }
}
</style>
